import { MasterApiClient } from './httpClient';
import { getTandCterritory } from '../helpers/projectInitUtil';

export const getFooter = async () => {
  const territoryName = getTandCterritory();

  const response = await MasterApiClient.get(
    `footer?territory=${territoryName}`
  );
  return response.data;
};
